<template lang="pug">
  .no-data
    .no-data__content
      i(:style="{ fontSize: fontSize }").iconfont.icon-wushuju
</template>

<script>
export default {
  props: {
    fontSize: {
      type: String,
      default () {
        return '150px'
      }
    }
  }
}
</script>

<style lang="stylus">
.no-data__content
  display flex
  justify-content center
  i
    color #E2E2E2
</style>
